import React, { useState, useContext, useEffect } from 'react';
import moment from 'moment';
import { TweenOneGroup } from 'rc-tween-one';
import { Page, Loadding } from '../../components';
import { getGoodsSpecPriceList, getGoodsListByDatetime } from '../../services/Supplier';
import { parsePrice, calcProfitRate } from '../../utils/Numeric';
import { getDatetime } from '../../services/Login';
import { toFixed2 } from '../../utils/Numeric';
import {
  InputNumber,
  Row, Col,
  Dropdown,
  Divider,
  Button,
  Tag,
  Form, Input, Select, DatePicker,
  Space, Menu,
  message,
  Modal,
  Checkbox
} from 'antd';
import {
  FormOutlined,
  CloseOutlined,
  SaveOutlined,
  LeftOutlined,
  RightOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
  DownCircleFilled,
  EditOutlined,
  DownOutlined,
  CheckCircleFilled,
  AuditOutlined,
  CaretDownOutlined
} from '@ant-design/icons';

import { MasterContext } from '../../App';
import { OrderContext } from '.';
import './style';

export default React.forwardRef((props, ref) => {
  const { warehouse, currency_rate, currentUser, authorities, user } = useContext(MasterContext);
  const { suppliers } = useContext(OrderContext);
  const { mode, order, orderGoods,
    orderPurchase, orderPurchaseGoods, reloadPurchaseGoods, downloadPurchase, onCloseCallback,
    orderPurchaseGoodsBatch, setOrderPurchaseGoodsBatch,
    onSavePurchaseCallback, setOrderPurchaseGoods,
    onSplitCountCallback, onCancelSplitCountCallback,
    onSplitSpecCallback, onCancelSplitSpecCallback,
    onReviewPurchaseSuppliersCallback,
    reloadOrderPurchase,
    setTabStatus } = props;
  const [isShowSplit, setShowSplit] = useState(false);
  const [supplierPrices, setSupplierPrices] = useState({});
  const [splitValues, setSplitValues] = useState([0]);
  const [splitValuesAdd, setSplitValuesAdd] = useState([0]);
  const [splitValuesJidu, setSplitValuesJidu] = useState([[0], [0], [0]]);
  const [deliveryDeadlineDate, setDeliveryDeadlineDate] = useState(orderPurchase ?
    orderPurchase.delivery_deadline_date : moment(order.delivery_deadline_date).add(-15, 'days').format('YYYY-MM-DD'));
  const [isShowSelect, setShowSelect] = useState(false);
  const [selectedGoods, setSelectedGoods] = useState({});
  const [orderSuppliers, setOrderSuppliers] = useState((orderPurchase ? (orderPurchase.supplier_ids || '') : '').split(',').filter(x => x.length > 0).map(y => parseInt(y)));
  const [addtionals, setAddtionals] = useState(orderPurchase ? orderPurchase.addtionals || '无' : '无');
  const [warehouseId, setWarehouseId] = useState(orderPurchase ? orderPurchase.warehouse_id : undefined);
  const [isReadonly, setReadonly] = useState(warehouseId !== undefined);
  const [form] = Form.useForm();
  const [pagination, setPagination] = useState({ limit: orderGoods.length > 200 ? 20 : 10, offset: 0 });
  const [page, setPage] = useState(0);

  const [pageCount, setPageCount] = useState(0);
  const isSingleSupplier = false;// orderSuppliers.length <= 1;
  const [orderDatetime, setOrderDatetime] = useState(orderPurchase ? orderPurchase.datetime : undefined);
  const [rate, setRate] = useState(1);
  const [currentRowIndex, setCurrentRowIndex] = useState(-1);

  ////////////////////////////////////////////////////////
  const [isShowEditPrice, setShowEditPrice] = useState(false);
  const [priceList, setPriceList] = useState([]);
  const [isPriceListLoading, setPriceListLoading] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(undefined);
  const onEditPriceOK = () => {
    if (!selectedGoods.supplier_id || !selectedPrice) return undefined;
    const temp = [].concat(orderPurchaseGoods);
    const find = temp.find(x => x.id === selectedGoods.id);
    if (find) {
      find.price_start_time = selectedPrice.start_time;
      find.price = selectedPrice.price;
      setOrderPurchaseGoods(temp);
    }
    setShowEditPrice(false);
  }

  const parseRemark = (item) => {
    return item.remark;
    // if (item.remark) return item.remark;
    // else {
    //   const find = orderGoods.find(x=>x.id === item.id);
    //   if (find) return find.remark;
    //   else return '';
    // }
  }
  const onChangeEditPrice = (start_time) => {
    const find = priceList.find(x =>
      x.supplier_id === selectedGoods.supplier_id &&
      x.goods_id === selectedGoods.goods_id &&
      x.goods_spec_id === selectedGoods.goods_spec_id &&
      x.start_time === start_time
    );
    setSelectedPrice(find);
  }
  const onEditPrice = (goods) => {
    if (!goods.supplier_id) return undefined;

    setPriceListLoading(true);
    getGoodsSpecPriceList(goods.supplier_id, goods.goods_id, goods.goods_spec_id).then(data => {
      setPriceList(data);
      setPriceListLoading(false);
      setSelectedGoods(goods);
      setShowEditPrice(true);
    });
  }

  const editPrice = (goods) => {
    if (currentUser.category_id !== 1 && !authorities.find(x => x === 'edit_purchase_price')) {
      return undefined;
    }
    if (!orderPurchase || isReadonly) return undefined;
    if (!goods.supplier_id) return undefined;

    return <a><EditOutlined onClick={() => onEditPrice(goods)} /></a>
  }
  const editPriceBody = () => {
    return <div style={{ padding: '1rem' }}>
      <div>历史价格列表：</div>
      {
        isPriceListLoading && <Loadding />
      }
      {
        !isPriceListLoading && <Select onChange={onChangeEditPrice} style={{ width: '100%' }}>
          {
            priceList.map(x => (
              <Select.Option key={x.start_time} value={x.start_time}>{x.start_time} - [<strong>{x.price}</strong>]</Select.Option>
            ))
          }
        </Select>
      }
      <div style={{ padding: '1rem 0', display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={() => setShowEditPrice(false)}>取 消</Button>
        &nbsp;&nbsp;&nbsp;
        <Button disabled={!selectedPrice} onClick={onEditPriceOK} type="primary">确 定</Button>
      </div>
    </div>
  }
  /////////////////////////////////////////////////////////


  const onKeyDown = (e) => {
    switch (e.keyCode) {
      case 37:
        break;
      case 38:
        e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
        e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
        break;
      case 39:
        break;
      case 40:
        e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
        e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
        break;
    }
  }

  const onKeyUp = (e) => {
    e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
    e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
    switch (e.keyCode) {
      case 37:
        break;
      case 38: {
        const idx = e.target.id.split('-');
        const ele = document.getElementById(idx[0] + '-' + (parseInt(idx[1]) - 1));
        if (ele) ele.focus();
      }
        break;
      case 39:
        break;
      case 40: {
        const idx = e.target.id.split('-');
        const ele = document.getElementById(idx[0] + '-' + (parseInt(idx[1]) + 1));
        if (ele) ele.focus();
      }
        break;
    }
  }

  const onPressEnter = (e) => {
    e.preventDefault(); //阻止事件的默认行为，比如a标签的转向，但不阻止事件的冒泡传播
    e.stopPropagation() //阻止事件的冒泡传播，但不阻止其默认行为
    const idx = e.target.id.split('-');
    if (idx.length !== 2) return false;
    const ele = document.getElementById(idx[0] + '-' + (parseInt(idx[1]) + 1));
    if (!ele) {
      for (let i = 0; i < parseInt(idx[1]); i++) {
        const ele = document.getElementById(idx[0] + '-' + i);
        if (ele) {
          ele.focus();
          break;
        }
      }
    } else {
      ele.focus();
    }
    return false;
  }

  const updateSupplierSelect = (data) => {
    let isChange = false;
    const temp = [].concat(orderPurchaseGoods);
    temp.forEach(x => {
      if (x.supplier_id) {
        const find = orderSuppliers.find(y => y === x.supplier_id);
        if (!find) {
          x.supplier_id = undefined;
          x.price = undefined;
          x.price_start_time = undefined;
          isChange = true;
        }
      }
      x.supplierCount = 0;

      for (var key in data) {
        const find = orderSuppliers.find(y => y === parseInt(key));
        if (!find) continue;
        let isOk = false;
        for (let i = 0; i < data[key].length; i++) {
          const price = data[key][i];
          if (price.goods_id === x.goods_id && price.goods_spec_id === x.goods_spec_id) {
            if (x.supplier_id) {
              if (price.is_default) {
                x.supplier_id = parseInt(key);
                x.price = price.price;
                x.price_start_time = price.start_time;
                x.disabled = true;
                isOk = true;
              }
            } else {
              x.supplier_id = parseInt(key);
              x.price = price.price;
              x.price_start_time = price.start_time;
              x.disabled = true;
            }
            isChange = true;
            x.supplierCount += 1;
          }
        }
        if (isOk) {
          break;
        }
      }
    });
    if (isChange) {
      setOrderPurchaseGoods(temp);
    }
  }

  useEffect(() => {
    const arr = [];
    const temp = Object.assign(supplierPrices);
    orderSuppliers.forEach(id => {
      if (!temp.hasOwnProperty(id)) {
        arr.push(new Promise((resolve, reject) => {
          getGoodsListByDatetime(id, orderDatetime).then(data => {
            temp[id] = data;
            resolve(true);
          });
        }));
      }
    });
    if (arr.length > 0) {
      Promise.all(arr).then(() => {
        setSupplierPrices(temp);
        updateSupplierSelect(temp);
      });
    } else {
      updateSupplierSelect(temp);
    }
  }, [orderSuppliers]);

  useEffect(() => {
    const find = currency_rate.find(x => x.name === '美元');
    if (find && find.rate5) {
      setRate((find.rate5 / 100).toFixed(4));
    }
  }, [currency_rate])

  const showDownloadConfirm = (order, key) => {
    downloadPurchase(order, deliveryDeadlineDate, key);
  }
  const onPrePage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  }
  const onNextPage = () => {
    if (page < pageCount - 1) {
      setPage(page + 1);
    }
  }
  const onChangePagination = (value) => {
    setPagination({ limit: value, offset: 0 });
    setPage(0);
  }

  useEffect(() => {
    const count = Math.ceil(orderPurchaseGoods.filter(x => x.goods_flag === 0).length / pagination.limit);
    setPageCount(count);
  }, [pagination]);

  const getProfitRate = (goods_id, goods_spec_id, price) => {
    const find = orderGoods.find(x => x.goods_id === goods_id && x.goods_spec_id === goods_spec_id);
    if (find) {
      return calcProfitRate(find.price, price, rate);
    }
    return undefined;
  }

  useEffect(() => {
    if (!orderPurchase) {
      getDatetime().then(data => setOrderDatetime(data));
    }
  }, [])

  useEffect(() => {
    const temp = Object.assign(pagination);
    setPagination({ limit: temp.limit, offset: page * temp.limit });
  }, [page]);

  useEffect(() => {
    if (deliveryDeadlineDate) {
      const date = moment(deliveryDeadlineDate).format('YYYY-MM-DD');
      const temp = [].concat(orderPurchaseGoods);
      temp.forEach((x, i) => {
        temp[i].delivery_deadline_date = date;
      });
      setOrderPurchaseGoods(temp);
    }
  }, [deliveryDeadlineDate]);

  const reset = () => {
    const temp = [].concat(orderPurchaseGoods);
    temp.forEach(x => {
      x.supplier_id = undefined;
      x.price = undefined;
      x.price_start_time = undefined;
    });
    setOrderPurchaseGoods(temp);
  }

  const onClickSplitCount = (id, status) => {
    const goods = orderPurchaseGoods.find(x => x.id === id);
    setSelectedGoods(goods);
    if (status) {
      setSplitValues([1, goods.count - 1])
      const temp = [].concat(splitValuesJidu);
      if (goods.adjust_count_mon1 > 1) {
        temp[0] = [goods.adjust_count_mon1];
      } else {
        temp[0] = [0];
      }
      if (goods.adjust_count_mon2 > 1) {
        temp[1] = [goods.adjust_count_mon2];
      } else {
        temp[1] = [0];
      }
      if (goods.adjust_count_mon3 > 1) {
        temp[2] = [goods.adjust_count_mon3];
      } else {
        temp[2] = [0];
      }
      setSplitValuesJidu(temp);
      setSplitValuesAdd([goods.adjust_count_add])

      setShowSplit(true);
    } else {
      setSplitValues([]);
      if (onCancelSplitCountCallback) {
        onCancelSplitCountCallback(order.id, goods.id, () => reloadPurchaseGoods());
      }
    }
  }
  const onClickSplitSpec = (id, status) => {
    if (status) {
      onSplitSpecCallback(order.id, id, () => reloadPurchaseGoods());
    } else {
      if (onCancelSplitSpecCallback) {
        onCancelSplitSpecCallback(order.id, id, () => reloadPurchaseGoods());
      }
    }
  }

  const onClickSplitOk = () => {
    if (splitValues.length < 2) {
      return;
    }
    if (onSplitCountCallback) {
      onSplitCountCallback(
        order.id, selectedGoods.id, splitValues.map(x => ({
          count: x,
          pid: selectedGoods.id,
          count_mon1:  0,
          count_mon2: 0,
          count_mon3: 0,
          count_add: 0
        })), () => {
          setShowSplit(false);
          reloadPurchaseGoods();
        });
    }
  }

  const onClickSplitJiduOk = () => {
    const temp = [];
    splitValuesJidu.forEach((x, i) => {
      x.filter(z => z > 0).forEach(y => {
        temp.push({ count: y, idx: i });
      })
    });
    splitValuesAdd.filter(x => x > 0).forEach(y => {
      temp.push({ count: y, idx: 3 });
    });
    if (temp < 2) return;
    if (onSplitCountCallback) {
      onSplitCountCallback(
        order.id, selectedGoods.id, temp.map(x => ({
          count: x.count,
          pid: selectedGoods.id,
          count_mon1: x.idx === 0 ? x.count : 0,
          count_mon2: x.idx === 1 ? x.count : 0,
          count_mon3: x.idx === 2 ? x.count : 0,
          count_add: x.idx === 3 ? x.count : 0
        })), () => {
          setShowSplit(false);
          reloadPurchaseGoods();
        });
    }
  }

  const onChangeDelivery = (date, item) => {
    const temp = [].concat(orderPurchaseGoods);
    temp.find(x => x.id === item.id).delivery_deadline_date = date;
    setOrderPurchaseGoods(temp);
  }

  const renderNoPrice = (
    <span style={{ color: 'red' }}>无单价</span>
  );

  const onChangeSupplier = (id, goods) => {
    if (!id) {
      const temp = [].concat(orderPurchaseGoods);
      const find = orderPurchaseGoods.find(x => x.id === goods.id);
      if (find) {
        find.supplier_id = undefined;
        find.price = undefined;
        find.price_start_time = undefined;
        setOrderPurchaseGoods(temp);
      }
      return;
    }
    if (!supplierPrices.hasOwnProperty(id)) {
      getGoodsListByDatetime(id, orderDatetime).then(data => {
        //data = data.filter(x => moment(new Date()).isBefore(x.end_time) && moment(x.start_time).isBefore(moment(new Date())));
        supplierPrices[id] = data;
        setSupplierPrices(supplierPrices);
        if (goods === -1) {
          const temp = orderPurchaseGoods.map((item, index) => {
            const currentPrice = data.find(
              x => x.goods_id === item.goods_id && x.goods_spec_id === item.goods_spec_id) || {};
            return Object.assign(item, { supplier_id: id, price: currentPrice.price, price_start_time: currentPrice.start_time })
          })
          setOrderPurchaseGoods(temp);
        } else {
          const currentPrice = data.find(
            x => x.goods_id === goods.goods_id && x.goods_spec_id === goods.goods_spec_id) || {};
          const temp = [].concat(orderPurchaseGoods);
          const find = temp.find(x => x.id === goods.id);
          if (find) {
            find.supplier_id = id;
            find.price = currentPrice.price;
            find.price_start_time = currentPrice.start_time;
            find.disabled = true;
            setOrderPurchaseGoods(temp);
          }
        }
      });
    } else {
      const data = supplierPrices[id];
      if (goods === -1) {
        const temp = orderPurchaseGoods.map((item, index) => {
          const currentPrice = data.find(
            x => x.goods_id === item.goods_id && x.goods_spec_id === item.goods_spec_id) || {};
          return Object.assign(item, { supplier_id: id, price: currentPrice.price, price_start_time: currentPrice.start_time })
        })
        setOrderPurchaseGoods(temp);
      } else {
        const currentPrice = data.find(
          x => x.goods_id === goods.goods_id && x.goods_spec_id === goods.goods_spec_id) || {};

        const temp = [].concat(orderPurchaseGoods);
        const find = orderPurchaseGoods.find(x => x.id === goods.id);
        if (find) {
          find.supplier_id = id;
          find.price = currentPrice.price;
          find.price_start_time = currentPrice.start_time;
          find.disabled = true;
          setOrderPurchaseGoods(temp);
        }
      }
    }
  }

  const onChangeRemark = (e, id) => {
    const temp = [].concat(orderPurchaseGoods);
    const find = temp.find(x => x.id === id);
    if (find) find.remark = e.target.value.trim();
    setOrderPurchaseGoods(temp);
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const parseData = (values) => {
    values.supplier_ids = orderSuppliers.join(',');

    let avalidGoods = [];
    orderPurchaseGoods.filter(x => x.goods_flag === 0).forEach(x => {
      const temp = orderPurchaseGoods.filter(y => y.pid === x.id);
      if (temp.length > 0) {
        avalidGoods = avalidGoods.concat(temp);
      } else {
        avalidGoods = avalidGoods.concat([x]);
      }
    });
    const goods = avalidGoods.filter(x => x.supplier_id && x.price).map(x => (Object.assign({ delivery_deadline_date: moment(deliveryDeadlineDate).format('YYYY-MM-DD') }, x)));
    const invalidGoods = avalidGoods.filter(x => !x.supplier_id || !x.price);
    return {
      purchase: values,
      goods: goods,
      invalidGoods: invalidGoods
    }
  }

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      values.delivery_deadline_date = moment(values.delivery_deadline_date).format('YYYY-MM-DD');
      console.log('onSave:', values);
      if (orderSuppliers.length === 0) {
        message.error('请指定供应商！');
        return;
      }
      const data = parseData(values);
      if (data.goods.length === 0) {
        message.error('请为采购产品指定供应商！');
        return;
      }
      if (data.invalidGoods.length > 0) {
        message.error('部分产品未指定供应商或者供应商价格不存在！');
        return;
      }
      if (onSavePurchaseCallback) {
        onSavePurchaseCallback(order.id, data, () => {
          reloadOrderPurchase();
          reloadPurchaseGoods();
        });
      }
      setReadonly(true);
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onChangeSplit = (value, index, count) => {
    const temp = [].concat(splitValues);
    temp.splice(index);
    let total = 0;
    temp.forEach((item, index) => {
      total += item;
    });
    if ((total + value) < count) {
      temp[index] = value;
      temp[index + 1] = count - total - value;
    } else {
      temp[index] = count - total;
    }
    setSplitValues(temp);
  }

  const onChangeSplitJidu = (value, index, count, mIdx) => {
    const temp = [].concat(splitValuesJidu[mIdx]);
    temp.splice(index);
    let total = 0;
    temp.forEach((item, index) => {
      total += item;
    });
    if ((total + value) < count) {
      temp[index] = value;
      temp[index + 1] = count - total - value;
    } else {
      temp[index] = count - total;
    }
    const temp1 = [].concat(splitValuesJidu);
    temp1[mIdx] = temp;
    setSplitValuesJidu(temp1);
  }

  const onChangeSplitAdd = (value, index, count, mIdx) => {
    const temp = [].concat(splitValuesAdd);
    temp.splice(index);
    let total = 0;
    temp.forEach((item, index) => {
      total += item;
    });
    if ((total + value) < count) {
      temp[index] = value;
      temp[index + 1] = count - total - value;
    } else {
      temp[index] = count - total;
    }
    setSplitValuesAdd(temp);
  }

  const splitBody = () => {
    if (!selectedGoods) return undefined;
    if (order.type < 21)
      return <div style={{ padding: '2rem 1rem' }}>
        <span style={{ padding: '0rem 1rem' }}>采购数量:
        <strong>{selectedGoods.adjust_count}</strong>=
        {
            splitValues.map((item, index) => {
              let max = 0;
              splitValues.forEach((item, i) => {
                if (i < index) {
                  max += item;
                }
              })
              return <span>
                {index > 0 && '+'}
                <InputNumber
                  onFocus={() => setCurrentRowIndex(item.id)}
                  min={1}
                  max={selectedGoods.count - max}
                  value={item}
                  onChange={(value) => onChangeSplit(value, index, selectedGoods.count)}
                />
              </span>
            })
          }
        </span>
        <Button onClick={onClickSplitOk} type="primary">确定</Button>
      </div>
    else if (order.type === 21)
      return <div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>上季度追加:
        <strong>{selectedGoods.adjust_count_add}</strong>=
        {
              selectedGoods.adjust_count_add <= 1 && <span>{selectedGoods.adjust_count_add}</span>
            }
            {
              selectedGoods.adjust_count_add > 1 && splitValuesAdd.map((item, index) => {
                let max = 0;
                splitValuesAdd.forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_add - max}
                    value={item}
                    onChange={(value) => onChangeSplitAdd(value, index, selectedGoods.adjust_count_add, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(1月份):
        <strong>{selectedGoods.adjust_count_mon1}</strong>=
        {
              selectedGoods.adjust_count_mon1 <= 1 && <span>{selectedGoods.adjust_count_mon1}</span>
            }
            {
              selectedGoods.adjust_count_mon1 > 1 && splitValuesJidu[0].map((item, index) => {
                let max = 0;
                splitValuesJidu[0].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon1 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon1, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(2月份):
        <strong>{selectedGoods.adjust_count_mon2}</strong>=
        {
              selectedGoods.adjust_count_mon2 <= 1 && <span>{selectedGoods.adjust_count_mon2}</span>
            }
            {
              selectedGoods.adjust_count_mon2 > 1 && splitValuesJidu[1].map((item, index) => {
                let max = 0;
                splitValuesJidu[1].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon2 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon2, 1)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(3月份):
        <strong>{selectedGoods.adjust_count_mon3}</strong>=
        {
              selectedGoods.adjust_count_mon3 <= 1 && <span>{selectedGoods.adjust_count_mon3}</span>
            }
            {
              selectedGoods.adjust_count_mon3 > 1 && splitValuesJidu[2].map((item, index) => {
                let max = 0;
                splitValuesJidu[2].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon3 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon3, 2)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem 1rem' }}>
          <Button onClick={() => setShowSplit(false)}>取 消</Button>
      &nbsp;&nbsp;&nbsp;
      <Button onClick={onClickSplitJiduOk} type="primary">确 定</Button>
        </div>
      </div>
    else if (order.type === 22)
      return <div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>上季度追加:
        <strong>{selectedGoods.adjust_count_add}</strong>=
        {
              selectedGoods.adjust_count_add <= 1 && <span>{selectedGoods.adjust_count_add}</span>
            }
            {
              selectedGoods.adjust_count_add > 1 && splitValuesAdd.map((item, index) => {
                let max = 0;
                splitValuesAdd.forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_add - max}
                    value={item}
                    onChange={(value) => onChangeSplitAdd(value, index, selectedGoods.adjust_count_add, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(4月份):
        <strong>{selectedGoods.adjust_count_mon1}</strong>=
        {
              selectedGoods.adjust_count_mon1 <= 1 && <span>{selectedGoods.adjust_count_mon1}</span>
            }
            {
              selectedGoods.adjust_count_mon1 > 1 && splitValuesJidu[0].map((item, index) => {
                let max = 0;
                splitValuesJidu[0].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon1 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon1, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(5月份):
        <strong>{selectedGoods.adjust_count_mon2}</strong>=
        {
              selectedGoods.adjust_count_mon2 <= 1 && <span>{selectedGoods.adjust_count_mon2}</span>
            }
            {
              selectedGoods.adjust_count_mon2 > 1 && splitValuesJidu[1].map((item, index) => {
                let max = 0;
                splitValuesJidu[1].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon2 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon2, 1)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(6月份):
        <strong>{selectedGoods.adjust_count_mon3}</strong>=
        {
              selectedGoods.adjust_count_mon3 <= 1 && <span>{selectedGoods.adjust_count_mon3}</span>
            }
            {
              selectedGoods.adjust_count_mon3 > 1 && splitValuesJidu[2].map((item, index) => {
                let max = 0;
                splitValuesJidu[2].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon3 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon3, 2)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem 1rem' }}>
          <Button onClick={() => setShowSplit(false)}>取 消</Button>
      &nbsp;&nbsp;&nbsp;
      <Button onClick={onClickSplitJiduOk} type="primary">确 定</Button>
        </div>
      </div>
    else if (order.type === 23)
      return <div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>上季度追加:
            <strong>{selectedGoods.adjust_count_add}</strong>=
            {
              selectedGoods.adjust_count_add <= 1 && <span>{selectedGoods.adjust_count_add}</span>
            }
            {
              selectedGoods.adjust_count_add > 1 && splitValuesAdd.map((item, index) => {
                let max = 0;
                splitValuesAdd.forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_add - max}
                    value={item}
                    onChange={(value) => onChangeSplitAdd(value, index, selectedGoods.adjust_count_add, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(7月份):
            <strong>{selectedGoods.adjust_count_mon1}</strong>=
            {
              selectedGoods.adjust_count_mon1 <= 1 && <span>{selectedGoods.adjust_count_mon1}</span>
            }
            {
              selectedGoods.adjust_count_mon1 > 1 && splitValuesJidu[0].map((item, index) => {
                let max = 0;
                splitValuesJidu[0].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon1 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon1, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(8月份):
            <strong>{selectedGoods.adjust_count_mon2}</strong>=
            {
              selectedGoods.adjust_count_mon2 <= 1 && <span>{selectedGoods.adjust_count_mon2}</span>
            }
            {
              selectedGoods.adjust_count_mon2 > 1 && splitValuesJidu[1].map((item, index) => {
                let max = 0;
                splitValuesJidu[1].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon2 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon2, 1)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(9月份):
            <strong>{selectedGoods.adjust_count_mon3}</strong>=
            {
              selectedGoods.adjust_count_mon3 <= 1 && <span>{selectedGoods.adjust_count_mon3}</span>
            }
            {
              selectedGoods.adjust_count_mon3 > 1 && splitValuesJidu[2].map((item, index) => {
                let max = 0;
                splitValuesJidu[2].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon3 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon3, 2)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem 1rem' }}>
          <Button onClick={() => setShowSplit(false)}>取 消</Button>
          &nbsp;&nbsp;&nbsp;
          <Button onClick={onClickSplitJiduOk} type="primary">确 定</Button>
        </div>
      </div>
    else if (order.type === 24)
      return <div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>上季度追加:
            <strong>{selectedGoods.adjust_count_add}</strong>=
            {
              selectedGoods.adjust_count_add <= 1 && <span>{selectedGoods.adjust_count_add}</span>
            }
            {
              selectedGoods.adjust_count_add > 1 && splitValuesAdd.map((item, index) => {
                let max = 0;
                splitValuesAdd.forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_add - max}
                    value={item}
                    onChange={(value) => onChangeSplitAdd(value, index, selectedGoods.adjust_count_add, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(10月份):
            <strong>{selectedGoods.adjust_count_mon1}</strong>=
            {
              selectedGoods.adjust_count_mon1 <= 1 && <span>{selectedGoods.adjust_count_mon1}</span>
            }
            {
              selectedGoods.adjust_count_mon1 > 1 && splitValuesJidu[0].map((item, index) => {
                let max = 0;
                splitValuesJidu[0].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon1 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon1, 0)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(11月份):
            <strong>{selectedGoods.adjust_count_mon2}</strong>=
            {
              selectedGoods.adjust_count_mon2 <= 1 && <span>{selectedGoods.adjust_count_mon2}</span>
            }
            {
              selectedGoods.adjust_count_mon2 > 1 && splitValuesJidu[1].map((item, index) => {
                let max = 0;
                splitValuesJidu[1].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon2 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon2, 1)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem' }}>
          <span style={{ padding: '0rem 1rem' }}>采购数量(12月份):
            <strong>{selectedGoods.adjust_count_mon3}</strong>=
            {
              selectedGoods.adjust_count_mon3 <= 1 && <span>{selectedGoods.adjust_count_mon3}</span>
            }
            {
              selectedGoods.adjust_count_mon3 > 1 && splitValuesJidu[2].map((item, index) => {
                let max = 0;
                splitValuesJidu[2].forEach((item, i) => {
                  if (i < index) {
                    max += item;
                  }
                })
                return <span>
                  {index > 0 && '+'}
                  <InputNumber
                    min={1}
                    max={selectedGoods.adjust_count_mon3 - max}
                    value={item}
                    onChange={(value) => onChangeSplitJidu(value, index, selectedGoods.adjust_count_mon3, 2)}
                  />
                </span>
              })
            }
          </span>
        </div>
        <div style={{ padding: '0.5rem 1rem' }}>
          <Button onClick={() => setShowSplit(false)}>取 消</Button>
          &nbsp;&nbsp;&nbsp;
          <Button onClick={onClickSplitJiduOk} type="primary">确 定</Button>
        </div>
      </div>
  }

  const toggleItem = (id) => {
    const temp = [].concat(orderPurchaseGoods);
    const find = temp.find(x => x.id === id);
    find.disabled = false;
    setOrderPurchaseGoods(temp);
  }

  const initValue = [
    { name: ['delivery_deadline_date'], value: deliveryDeadlineDate ? moment(deliveryDeadlineDate, 'YYYY-MM-DD') : undefined },
    { name: ['order_id'], value: order.id },
    { name: ['warehouse_id'], value: warehouseId },
    { name: ['addtionals'], value: addtionals },
  ];

  const includes = (arr1, arr2) => {
    return arr2.every(val => arr1.includes(val));
  }

  const allValidSuppliers = () => {
    return suppliers.filter(x => x.goods_count > 0);
  }

  const filteredSuppliers = (id) => {
    return suppliers.filter(x => orderSuppliers.indexOf(x.id) > -1);
  }

  const filterSuppliers = (id) => {
    const temp = orderPurchaseGoods.map(x => (x.goods_spec_id));
    const order_goods_id = temp.filter((item, index, temp) => {
      return temp.indexOf(item, 0) === index
    });

    const arr = order_goods_id.map(String);
    let arr1 = [];
    if (isSingleSupplier) {
      arr1 = [].concat(suppliers.filter(x => orderSuppliers.indexOf(x.id) > -1 && x.goods_count > 0 && includes(x.goods_spec_id.split(','), arr)));
    }
    else {
      arr1 = [].concat(suppliers.filter(x => orderSuppliers.indexOf(x.id) > -1 && x.goods_count > 0 && x.goods_spec_id.split(',').indexOf(id + '') > -1));
    }
    return arr1;
  }

  const sum = { count: 0, adjust_count: 0, amount: 0 };

  orderPurchaseGoods.filter(x => x.goods_flag === 0).forEach(y => {
    if (y.count) {
      sum.count += y.count;
      sum.adjust_count += y.adjust_count;
      if (orderPurchaseGoods.filter(z => z.pid === y.id).length > 0) {
        orderPurchaseGoods.filter(z => z.pid === y.id).forEach(m => {
          sum.amount += m.adjust_count * m.price;
        })
      } else {
        sum.amount += y.adjust_count * y.price;
      }
    }
  });

  const splitButton = (onClick, isSplit) => {
    if (isSingleSupplier) return undefined;
    if (isSplit)
      return <Button disabled={isReadonly} onClick={onClick} style={{ padding: '0 0 0 0.1rem' }} type="link" size="small">
        [拆分]
      </Button>;
    else
      return <Button disabled={isReadonly} danger onClick={onClick} style={{ padding: '0 0 0 0.1rem' }} type="link" size="small">
        [取消]
        </Button>;
  }

  const renderRow = (item, index, parent, split, totalIndex) => {
    const children = orderPurchaseGoods.filter(x => x.pid === item.id);
    if ((children.length === 0 && item.goods_flag === 0) || isSingleSupplier) return normalRow(item, index);
    if (children.length === 0 && item.goods_flag === 1 && parent.goods_flag === 0) return splitCountRow(item, index, parent, split, totalIndex);
    if (children.length === 0 && item.goods_flag === 2 && parent.goods_flag === 0) return splitSpecRow(item, index, parent, split);

    let total = 0;
    const all = [];
    children.forEach(c => {
      const t = orderPurchaseGoods.filter(y => y.pid === c.id).map(x => (Object.assign({ parent: c, parent2: item }, x)))
      if (t.length === 0) { total += 1; all.push([Object.assign({ parent: c, parent2: item }, c)]) }
      else { total += t.length; all.push(t) }
    })
    if (children.length === total) {
      return children.map((child, childIndex) => {
        return renderRow(child, childIndex, item, children.length, totalIndex);
      });
    }

    if (children[0].goods_flag === 1) {
      return all.map((a, aindex) => {
        return renderCountSpec(a, aindex, total, totalIndex);
      })
    }
    if (children[0].goods_flag === 2) {
      return all.map((a, aindex) => {
        return renderSpecCount(a, aindex, total);
      })
    }
  }

  const renderSpecCount = (item, index, total) => {
    let itemTotalCount = 0;
    item.forEach(x => (itemTotalCount += x.count));
    return item.map((i, iIndex) => {
      return renderCountSpec2(i, iIndex, item.length, index, total, itemTotalCount);
    })
  }

  const renderCountSpec = (item, index, total, totalIndex) => {
    let itemTotalCount = 0;
    item.forEach(x => (itemTotalCount += x.count));
    return item.map((i, iIndex) => {
      return renderCountSpec1(i, iIndex, item.length, index, total, itemTotalCount, totalIndex);
    })
  }

  const renderCountSpec2 = (item, itemIndex, itemTotal, index, total, itemTotalCount) => {
    const parent = item.parent;
    const parent2 = item.parent2;
    return <tr style={currentRowIndex === item.id ? { backgroundColor: 'rgb(220, 222, 245)' } : {}}>
      {(itemIndex === 0 && index === 0) && <td className="td" rowSpan={total} >{index + 1}</td>}
      {(itemIndex === 0 && index === 0) && <td className="td" rowSpan={total} >{parent.goods_name}</td>}
      {(itemIndex === 0 && index === 0) && <td className="td" rowSpan={total}>{parent2.goods_spec_name}</td>
      }
      {(itemIndex === 0 && itemTotal > 1) && <td className="td" rowSpan={itemTotal}>{item.goods_spec_name}</td>}
      {(itemIndex === 0 && itemTotal > 1) && <td className="td" align="right" rowSpan={itemTotal}>{itemTotalCount}
        {
          splitButton(() => onClickSplitCount(parent.id, false), false)
        }
      </td>}
      {itemTotal > 1 && <td className="td" align="right" style={{ color: item.count !== item.adjust_count ? 'red' : '' }}>{item.count} - {item.adjust_count}</td>}
      {itemTotal === 1 && <td className="td"> {item.goods_spec_name}</td>}
      {itemTotal === 1 && <td className="td" align="right" colSpan={2} style={{ color: item.count !== item.adjust_count ? 'red' : '' }}> {item.count} - {item.adjust_count}
        {
          splitButton(() => onClickSplitCount(parent.id, true), true)
        }
      </td>}
      <td>{item.count}</td>
      {!isSingleSupplier && <td className="td">
        <div style={{ display: 'flex', width: '100%' }}>
          <Select
            onFocus={() => setCurrentRowIndex(item.id)}
            allowClear
            disabled={item.disabled !== false && orderPurchase !== undefined}
            size="small"
            showSearch="true"
            placeholder="请选择供应商"
            suffixIcon={item.supplierCount > 1 ? <DownCircleFilled style={{ color: '#eb2f96' }} /> : <DownOutlined />}
            value={item.supplier_id}
            onChange={(value) => onChangeSupplier(value, item)}
            style={{ width: '100%' }}
          >
            {filterSuppliers(item.goods_spec_id).map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
          {orderPurchase !== undefined && <Button onClick={() => toggleItem(item.id)} disabled={isReadonly || item.disabled === false} type="link" size="small" icon={<EditOutlined />}></Button>}
        </div>
      </td>
      }
      <td className="td" align="right" >{parsePrice(item.price)}{editPrice(item)}</td>
      <td className="td" align="right" >{parsePrice(((item.adjust_count * item.price) || 0).toFixed(2))}</td>
      <td className="td" align="right">{getProfitRate(item.goods_id, item.goods_spec_id, item.price)}</td>
      <td className="td" align="right"></td>
      <td className="td">
        <Input
          id={'pr-' + index}
          onFocus={() => setCurrentRowIndex(item.id)}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onPressEnter={(e) => onPressEnter(e, index)}
          value={parseRemark(item)}
          disabled={isReadonly}
          onChange={(value) => onChangeRemark(value, item.id)}
          style={{ backgroundColor: '#FFD700' }}
          size="small" />
      </td>
    </tr>
  }

  const renderCountSpec1 = (item, itemIndex, itemTotal, index, total, itemTotalCount, totalIndex) => {
    const parent = item.parent;
    return <tr style={currentRowIndex === item.id ? { backgroundColor: 'rgb(220, 222, 245)' } : {}}>
      {(itemIndex === 0 && index === 0) && <td className="td" rowSpan={total} >{totalIndex + 1}</td>}
      {(itemIndex === 0 && index === 0) && <td className="td" rowSpan={total} >{parent.goods_name}</td>}
      {(itemIndex === 0 && itemTotal > 1) && <td className="td" rowSpan={itemTotal}>{parent.goods_spec_name}
        {
          parent.part_count > 0 ? splitButton(() => onClickSplitSpec(parent.id, false), false) : undefined
        }
      </td>
      }
      {(itemIndex === 0 && itemTotal === 1) && <td className="td" colSpan={2}>{parent.goods_spec_name}
        {
          parent.part_count > 0 ? splitButton(() => onClickSplitSpec(parent.id, true), true) : undefined
        }
      </td>
      }
      {itemTotal > 1 && <td className="td">{item.goods_spec_name}  </td>}

      {(itemIndex === 0 && itemTotal > 1) && <td className="td" align="right" rowSpan={itemTotal}>{itemTotalCount}
      </td>}
      {itemTotal > 1 && <td className="td" align="right" style={{ color: item.count !== item.adjust_count ? 'red' : '' }}> {item.count} - {item.adjust_count}

      </td>
      }
      {itemTotal === 1 && <td className="td" align="right" colSpan={2} style={{ color: item.count !== item.adjust_count ? 'red' : '' }}> {item.count} - {item.adjust_count}
      </td>
      }
      <td>{item.count}</td>
      {!isSingleSupplier && <td className="td">
        <div style={{ display: 'flex', width: '100%' }}>
          <Select
            onFocus={() => setCurrentRowIndex(item.id)}
            allowClear
            disabled={item.disabled !== false && orderPurchase !== undefined}
            size="small"
            showSearch="true"
            placeholder="请选择供应商"
            suffixIcon={item.supplierCount > 1 ? <DownCircleFilled style={{ color: '#eb2f96' }} /> : <DownOutlined />}
            value={item.supplier_id}
            onChange={(value) => onChangeSupplier(value, item)}
            style={{ width: '100%' }}
          >
            {filterSuppliers(item.goods_spec_id).map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
          {orderPurchase !== undefined && <Button onClick={() => toggleItem(item.id)} disabled={isReadonly || item.disabled === false} type="link" size="small" icon={<EditOutlined />}></Button>}
        </div>
      </td>
      }
      <td className="td" align="right" >{parsePrice(item.price)}{editPrice(item)}</td>
      <td className="td" align="right" >{parsePrice(((item.adjust_count * item.price) || 0).toFixed(2))}</td>
      <td className="td" align="right">{getProfitRate(item.goods_id, item.goods_spec_id, item.price)}</td>
      <td className="td" align="right"></td>
      <td className="td">
        <Input
          id={'pr-' + totalIndex}
          onFocus={() => setCurrentRowIndex(item.id)}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onPressEnter={(e) => onPressEnter(e)}
          disabled={isReadonly}
          value={parseRemark(item)}
          onChange={(value) => onChangeRemark(value, item.id)}
          style={{ backgroundColor: '#FFD700' }}
          size="small" />
      </td>
    </tr>
  }
  const splitSpecRow = (item, index, parent, splits) => {
    return (
      <tr style={currentRowIndex === item.id ? { backgroundColor: 'rgb(220, 222, 245)' } : {}}>
        {index === 0 && <td className="td" rowSpan={splits} >{index + 1}</td>}
        {index === 0 && <td className="td" rowSpan={splits} >{parent.goods_name}</td>}
        {index === 0 && <td className="td" rowSpan={splits}>{parent.goods_spec_name}
          {
            parent.part_count > 0 ? splitButton(() => onClickSplitSpec(parent.id, false), false) : undefined
          }
        </td>
        }
        <td className="td">{item.goods_spec_name}  </td>
        <td className="td" align="right" colSpan={2} style={{ color: item.count !== item.adjust_count ? 'red' : '' }}> {item.count} - {item.adjust_count}
          {
            parent.goods_flag === 0 && splitButton(() => onClickSplitCount(item.id, true), true)
          }
        </td>
        <td>{toFixed2((item.count*1.0/item.pcs_per_carton)/item.carton_count_per_pallet,2)}</td>
        {!isSingleSupplier && <td className="td">
          <div style={{ display: 'flex', width: '100%' }}>
            <Select
              onFocus={() => setCurrentRowIndex(item.id)}
              allowClear
              disabled={item.disabled !== false && orderPurchase !== undefined}
              size="small"
              showSearch="true"
              placeholder="请选择供应商"
              suffixIcon={item.supplierCount > 1 ? <DownCircleFilled style={{ color: '#eb2f96' }} /> : <DownOutlined />}
              value={item.supplier_id}
              onChange={(value) => onChangeSupplier(value, item)}
              style={{ width: '100%' }}
            >
              {filterSuppliers(item.goods_spec_id).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
            {orderPurchase !== undefined && <Button onClick={() => toggleItem(item.id)} disabled={isReadonly || item.disabled === false} type="link" size="small" icon={<EditOutlined />}></Button>}
          </div>
        </td>
        }
        <td className="td" align="right" >{parsePrice(item.price)}{editPrice(item)}</td>
        <td className="td" align="right" >{parsePrice(((item.adjust_count * item.price) || 0).toFixed(2))}</td>
        <td className="td" align="right">{getProfitRate(item.goods_id, item.goods_spec_id, item.price)}</td>
        <td className="td" align="right"></td>
        <td className="td">
          <Input
            id={'pr-' + index}
            onFocus={() => setCurrentRowIndex(item.id)}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onPressEnter={(e) => onPressEnter(e)}
            disabled={isReadonly}
            value={parseRemark(item)}
            onChange={(value) => onChangeRemark(value, item.id)}
            style={{ backgroundColor: '#FFD700' }}
            size="small" />
        </td>
      </tr>)
  }

  const splitCountRow = (item, index, parent, splits, totalIndex) => {
    return (
      <tr style={currentRowIndex === item.id ? { backgroundColor: 'rgb(220, 222, 245)' } : {}}>
        {index === 0 && <td className="td" rowSpan={splits} >{totalIndex + 1}</td>}
        {index === 0 && <td className="td" rowSpan={splits} >{parent.goods_name}</td>}
        {parent.part_count > 0 && <td className="td" colSpan={2}>{item.goods_spec_name}
          {
            item.part_count > 0 ? splitButton(() => onClickSplitSpec(item.id, true), item.part_count) : undefined
          }
        </td>
        }
        {(parent.part_count === 0 && index === 0) && <td className="td" rowSpan={splits} colSpan={2}>{item.goods_spec_name}
        </td>
        }
        {index === 0 && <td className="td" align="right" rowSpan={splits}> {parent.count}
          {
            splitButton(() => onClickSplitCount(parent.id, false), false)
          }
        </td>
        }
        <td className="td" align="right" style={{ color: item.count !== item.adjust_count ? 'red' : '' }}> {item.count} - {item.adjust_count} </td>
        <td>{toFixed2((item.count*1.0/item.pcs_per_carton)/item.carton_count_per_pallet,2)}</td>
        {!isSingleSupplier && <td className="td">
          <div style={{ display: 'flex', width: '100%' }}>
            <Select
              onFocus={() => setCurrentRowIndex(item.id)}
              allowClear
              disabled={item.disabled !== false && orderPurchase !== undefined}
              size="small"
              showSearch="true"
              placeholder="请选择供应商"
              suffixIcon={item.supplierCount > 1 ? <DownCircleFilled style={{ color: '#eb2f96' }} /> : <DownOutlined />}
              value={item.supplier_id}
              onChange={(value) => onChangeSupplier(value, item)}
              style={{ width: '100%' }}
            >
              {filterSuppliers(item.goods_spec_id).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
            {orderPurchase !== undefined && <Button onClick={() => toggleItem(item.id)} disabled={isReadonly || item.disabled === false} type="link" size="small" icon={<EditOutlined />}></Button>}
          </div>
        </td>
        }
        <td className="td" align="right">{parsePrice(item.price)}{editPrice(item)}</td>
        <td className="td" align="right">{parsePrice(((item.adjust_count * item.price) || 0).toFixed(2))}</td>
        <td className="td" align="right">{getProfitRate(item.goods_id, item.goods_spec_id, item.price)}</td>
        <td className="td" align="right"></td>
        <td className="td">
          <Input
            id={'pr-' + totalIndex}
            onFocus={() => setCurrentRowIndex(item.id)}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onPressEnter={(e) => onPressEnter(e)}
            disabled={isReadonly}
            value={parseRemark(item)}
            onChange={(value) => onChangeRemark(value, item.id)}
            style={{ backgroundColor: '#FFD700' }}
            size="small" />
        </td>
      </tr>)
  }
  const normalRow = (item, index) => {
    return (
      <tr style={currentRowIndex === item.id ? { backgroundColor: 'rgb(220, 222, 245)' } : {}}>
        <td className="td">{index + 1}</td>
        <td className="td">{item.goods_name}</td>
        <td className="td" colSpan={2}>{item.goods_spec_name}
          {
            item.part_count > 0 ? splitButton(() => onClickSplitSpec(item.id, true), item.part_count) : undefined
          }
        </td>
        <td className="td" align="right" colSpan={2} style={{ color: item.count !== item.adjust_count ? 'red' : '' }}> {item.count} - {item.adjust_count}
          {
            splitButton(() => onClickSplitCount(item.id, true), true)
          }
        </td>
        <td>{toFixed2((item.count*1.0/item.pcs_per_carton)/item.carton_count_per_pallet,2)}</td>
        {!isSingleSupplier && <td className="td">
          <div style={{ display: 'flex', width: '100%' }}>
            <Select
              onFocus={() => setCurrentRowIndex(item.id)}
              allowClear
              disabled={item.disabled !== false && orderPurchase !== undefined}
              size="small"
              showSearch="true"
              placeholder="请选择供应商"
              suffixIcon={item.supplierCount > 1 ? <DownCircleFilled style={{ color: '#eb2f96' }} /> : <DownOutlined />}
              value={item.supplier_id}
              onChange={(value) => onChangeSupplier(value, item)}
              style={{ width: '100%' }}
            >
              {filterSuppliers(item.goods_spec_id).map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
            {orderPurchase !== undefined && <Button onClick={() => toggleItem(item.id)} disabled={isReadonly || item.disabled === false} type="link" size="small" icon={<EditOutlined />}></Button>}
          </div>
        </td>
        }
        <td className="td" align="right">{parsePrice(item.price)}{editPrice(item)}</td>
        <td className="td" align="right">{parsePrice(((item.adjust_count * item.price) || 0).toFixed(2))}</td>
        <td className="td" align="right">{getProfitRate(item.goods_id, item.goods_spec_id, item.price)}</td>
        <td className="td" align="right"></td>
        <td className="td">
          <Input
            id={'pr-' + index}
            onFocus={() => setCurrentRowIndex(item.id)}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onPressEnter={(e) => onPressEnter(e)}
            disabled={isReadonly}
            value={parseRemark(item)}
            onChange={(value) => onChangeRemark(value, item.id)}
            style={{ backgroundColor: '#FFD700' }}
            size="small" />
        </td>
      </tr>)
  }

  const renderPage = (rows) => {
    const arr = [];
    arr.push(<span>共<strong>{rows.filter(x => x.goods_flag === 0).length}</strong>条数据</span>);
    if (rows.length > 10) {
      arr.push(<span style={{ marginRight: '1.5rem' }}>,&nbsp;每页显示&nbsp;<Select
        onChange={onChangePagination} value={pagination.limit}
        size="small">
        <Select.Option value={10}>10</Select.Option>
        {rows.length > 10 && <Select.Option value={20}>20</Select.Option>}
        {rows.length > 20 && <Select.Option value={30}>30</Select.Option>}
        {rows.length > 30 && <Select.Option value={50}>50</Select.Option>}
        {rows.length > 50 && <Select.Option value={100}>100</Select.Option>}
      </Select>&nbsp;条</span>)
    }

    if (pageCount <= 1) {
      return arr;
    }
    if (pageCount > 4) {
      arr.push(<Button size="small" disabled={page === 0} onClick={onPrePage} type="link" icon={<LeftOutlined />}></Button>);
    }
    for (let i = 0; i < pageCount; i++) {
      if (page === i) {
        arr.push(<Button size="small">{i + 1}</Button>)
      } else {
        arr.push(<Button onClick={() => setPage(i)} size="small" type="link">{i + 1}</Button>)
      }
    }
    if (pageCount > 4) {
      arr.push(<Button size="small" disabled={page === pageCount - 1} onClick={onNextPage} type="link" icon={<RightOutlined />}></Button>);
    }
    return arr;
  }

  const handleSelectClose = (i, name) => {
    Modal.confirm({
      title: '确定删除当前供应商吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const temp = [].concat(orderSuppliers);
        temp.splice(i, 1);
        setOrderSuppliers(temp);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleReviewSuppliers = () => {
    Modal.confirm({
      title: '审核确认',
      icon: <ExclamationCircleOutlined />,
      content: <strong>确定当前采购供应商审核通过吗?</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onReviewPurchaseSuppliersCallback(order.id, { is_reviewed: true }, reloadOrderPurchase)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const forSelectMap = (tag, index) => {
    const tagElem = (
      <Tag
        style={{ margin: '0 1rem 1rem 0', height: '32px', display: 'inline-flex', alignItems: 'center' }}
        closable={!isReadonly}
        onClose={e => {
          e.preventDefault();
          handleSelectClose(index, tag);
        }}
      >
        {tag}
      </Tag>
    );
    return (
      <span key={tag} style={{ height: '32px', display: 'inline-block' }}>
        {tagElem}
      </span>
    );
  };

  const renderSuppliers = () => {
    const tagChild = orderSuppliers.map((x, i) => forSelectMap((suppliers.find(y => x === y.id) || {}).name, i));
    return <TweenOneGroup
      enter={{
        scale: 1,
        opacity: 0,
        type: 'from',
        duration: 100,
        onComplete: e => {
          e.target.style = '';
        },
      }}
      leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
      appear={false}
    >
      {tagChild}
    </TweenOneGroup>
  }

  const checkButtonIcon = (<CheckCircleFilled style={{ color: '#52c41a' }} />);
  const errorButtonIcon = (<ExclamationCircleOutlined style={{ color: '#eb2f96' }} />);

  const handleChange = (value) => {
    if (!value) return;
    setOrderSuppliers(value.map(x => x.value));
  };

  const handleSelectConfirm = (value) => {
    if (!value) return;
    const temp = [].concat(orderSuppliers).concat([value]);
    setOrderSuppliers(temp);
    setShowSelect(false);
  };

  const onMenuDownload = (e) => {
    showDownloadConfirm(order, e.key);
  }

  const downloadMenu = (
    <Menu onClick={onMenuDownload}>
      <Menu.Item key="1">普通模板</Menu.Item>
      {(order.type === 21 || order.type === 22 || order.type === 23 || order.type === 24) && <Menu.Item key="2">季度单模板</Menu.Item>}
    </Menu>
  );


  return (
    <Form style={{ height: '100%' }} form={form} preserve={false} onFinish={onSave} fields={initValue} >
      <Row style={{ height: '100%' }}>
        <Col flex="340px" className="order-new-left-panel">
          <Row>
            <Col span={24}>
              <Form.Item label="交货期限" name="delivery_deadline_date" rules={[{ required: true, message: '请选择供应商交货期限!' }]} >
                <DatePicker
                  disabled={isReadonly}
                  onChange={setDeliveryDeadlineDate}
                  style={{ width: '100%' }}
                  placeholder="请选择交货期限" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="送货地址" name="warehouse_id" rules={[{ required: true, message: '请选择送货地址!' }]}>
                <Select
                  disabled={isReadonly}
                  onChange={(value) => setWarehouseId(value)}
                  showSearch="true"
                  optionFilterProp="children"
                  placeholder="请选择送货地址"
                >
                  {warehouse.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {`${item.name}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="附加条款" name="addtionals" rules={[{ required: true, message: '请输入附加条款!' }]} >
                <Input.TextArea
                  autoSize={{ minRows: 4, maxRows: 4 }}
                  disabled={isReadonly}
                  onChange={(e) => setAddtionals(e.target.value)}
                  placeholder="请输入附加条款"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="　订单汇率">
                1美元 = {rate}元
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="供应商列表">
                <div style={{ width: '100%' }}>
                  <Select
                    disabled={isReadonly}
                    optionFilterProp="children"
                    mode="multiple"
                    placeholder="请选择供应商"
                    labelInValue={true}
                    showSearch="true"
                    value={orderSuppliers.map(x => ({ label: suppliers.find(y => y.id === x).name, value: x }))}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                  >
                    {allValidSuppliers().filter(x => orderSuppliers.indexOf(x.id) < 0).map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        [{item.abbr}]-{item.name}
                      </Select.Option>
                    ))}
                  </Select>
                  {/* {renderSuppliers()}
                  {isShowSelect && (<Select
                    mode="tags"
                    style={{ width: '160px' }}
                    disabled={isReadonly}
                    showSearch="true"
                    placeholder="请选择供应商"
                    onBlur={(value) => handleSelectConfirm(value)}
                  >
                    {allValidSuppliers().filter(x => orderSuppliers.indexOf(x.id) < 0).map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>)
                  } */}
                  {/* {(!isShowSelect && !isReadonly) && (
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowSelect(true)}>添加</Button>
                  )} */}
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col flex="calc(100% - 400px)" style={{ padding: '1rem' }}>
          <Row style={{ padding: '0' }}>
            <Col span={24}>
              <div style={{ padding: '0.25rem 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                  {renderPage(orderPurchaseGoods)}
                </div>
                <Button onClick={reset} disabled={isReadonly} type="link" size="small">清空</Button>
              </div>
              <table className="goods_table" border="1">
                <thead>
                  <tr>
                    <th className="th" style={{ backgroundColor: '#f0f0f0' }} width="32px">#</th>
                    <th className="th" style={{ backgroundColor: '#f0f0f0' }}>产品名称</th>
                    <th className="th" style={{ backgroundColor: '#f0f0f0' }} colSpan={2}>产品号</th>
                    <th className="th" style={{ backgroundColor: '#f0f0f0' }} colSpan={2}>订单数量-采购数量</th>
                    <th className="th" style={{ backgroundColor: '#f0f0f0' }}>托数</th>
                    {!isSingleSupplier && <th className="th">供应商</th>}
                    <th className="th">采购单价</th>
                    <th className="th">采购金额</th>
                    <th className="th">毛利润(%)</th>
                    <th className="th">利润率(%)</th>
                    <th className="th">备注</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    orderPurchaseGoods.filter(x => x.goods_flag === 0).map((item, index) => {
                      if (index < pagination.offset || index > pagination.offset + pagination.limit - 1) {
                        return undefined;
                      }
                      return renderRow(item, index, undefined, undefined, index);
                    })
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td className="td" align="right" colspan={4}><strong>合计</strong></td>
                    <td className="td" align="right" colspan={2} ><strong>{sum.count} - {sum.adjust_count}</strong></td>
                    <td className="td" align="right" colspan={isSingleSupplier ? 2 : 3}><strong>{parsePrice(sum.amount.toFixed(2))}</strong></td>
                    <td className="td"></td>
                    <td className="td"></td>
                    <td className="td"></td>
                  </tr>
                </tfoot>
              </table>
            </Col>
          </Row>
          <Divider style={{ margin: '0' }} />
          <div className="page-footer">
            <div>
              {
                (isReadonly && orderPurchase) && <span>
                  采购状态： {
                    orderPurchase.is_reviewed && '[' + user.find(x => x.id === orderPurchase.reviewer_id)?.name + ']'
                  }
                  {
                    orderPurchase.is_reviewed ?
                      <span style={{ color: '#52c41a' }}>已审核 {checkButtonIcon}</span> :
                      <span style={{ color: '#EE1111' }}><strong>待审核...{errorButtonIcon}</strong></span>}
                </span>
              }
            </div>
            <Space size="large">
              {
                isReadonly &&
                <Dropdown placement="bottomLeft" overlay={downloadMenu} trigger={['click']}>
                  <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <DownloadOutlined /> &nbsp;下载采购合同<CaretDownOutlined />
                  </a>
                </Dropdown>
              }
              {onClose && <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>}
              {
                !isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button htmlType="submit" type="primary" icon={<SaveOutlined />}>保 存</Button>
                </div>
              }
              {
                (isReadonly && orderPurchase && !orderPurchase.is_reviewed) && <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button onClick={handleReviewSuppliers} danger type="primary" icon={<AuditOutlined />}>采购审核</Button>
                </div>
              }
              {
                isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button onClick={() => setReadonly(false)} type="primary" icon={<FormOutlined />}>编 辑</Button>
                </div>
              }
            </Space>
          </div>
          <div style={{ height: '4rem' }}></div>
        </Col>
      </Row>
      <Page
        title={`拆分采购[${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]`}
        width="75vw"
        onCloseCallback={() => setShowSplit(false)}
        body={splitBody()}
        visible={isShowSplit}
      />
      <Page
        title={`修改采购价格[${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]`}
        width="620px"
        onCloseCallback={() => setShowEditPrice(false)}
        body={editPriceBody()}
        visible={isShowEditPrice}
      />
    </Form>
  )
});
